import { useApi } from '@/api';
import { TableSkeleton } from '@/components';
import { transformString } from '@/utils';
import { tokensMapping } from '@/utils/tokens';
import {
  CryptoIcon,
  CurrencyValue,
  DataTable,
  EtherScanPictogram,
  Flex,
  FormattedNumber,
  RelativeDateTime
} from '@blockanalitica/ui';
import { TableColumn } from '@blockanalitica/ui/package/types/src/components/molecules/DataTable';

export default function BuybackEventsTable() {
  const [data, error] = useApi({
    url: '/sbe/swaps/',
    queryParams: {
      p_size: 10,
      operation: 'buyback'
    }
  });

  if (error) {
    throw error;
  }

  if (data) {
    const columns: TableColumn[] = [
      {
        header: 'Event',
        getCell: (row) => transformString(row.event) + ' 🔥',
        columnSize: ['minmax(80px, auto)']
      },
      {
        header: (
          <Flex
            display="flex"
            flexDirection="row"
            alignItems="center"
            gap="3xs">
            USDS
            <CryptoIcon
              name="USDS"
              address={tokensMapping('USDS').address}
              size="0"
            />
          </Flex>
        ),
        getCell: (row) => (
          <CurrencyValue
            value={row.usds_amount * -1}
            options={{
              iconSize: '0'
            }}
          />
        ),
        cellAlign: 'flex-end',
        headerAlign: 'flex-end',
        sortingField: 'usds_amount'
      },
      {
        header: (
          <Flex
            display="flex"
            flexDirection="row"
            alignItems="center"
            gap="3xs">
            SKY
            <CryptoIcon
              name="SKY"
              address={tokensMapping('SKY').address}
              size="0"
            />
          </Flex>
        ),
        getCell: (row) => (
          <CurrencyValue
            value={row.sky_amount}
            options={{
              iconSize: '0'
            }}
          />
        ),
        cellAlign: 'flex-end',
        headerAlign: 'flex-end',
        sortingField: 'sky_amount_usd'
      },
      {
        header: 'Price',
        getCell: (row) => (
          <FormattedNumber
            value={row.price}
            options={{
              formatNumberOptions: {
                notation: 'standard',
                maximumFractionDigits: 4
              },
              suffix: (
                <Flex color="muted" fontSize="-2">
                  USDS/SKY
                </Flex>
              )
            }}
          />
        ),
        cellAlign: 'flex-end',
        headerAlign: 'flex-end',
        sortingField: 'price'
      },
      {
        header: 'Time',
        getCell: (row) => (
          <Flex gap={['xs', '2xs']} color="muted">
            <RelativeDateTime value={row.datetime} />
            <a
              href={`https://etherscan.io/tx/${row.tx_hash}`}
              target="_blank"
              rel="noreferrer">
              <EtherScanPictogram size="0" />
            </a>
          </Flex>
        ),
        cellAlign: 'flex-end',
        headerAlign: 'flex-end',
        sortingField: 'datetime'
      }
    ];

    return (
      <DataTable
        rows={data['results']}
        columns={columns}
        getKey={(row) => row.order_index}
      />
    );
  }
  return <TableSkeleton />;
}
